export default __webpack_public_path__ + "static/media/services (3).ae91b1c0.jpg";